import { GetterTree } from 'vuex';
import { State } from '@/store/modules/alertV2/tagGrouping/tagGrouping.store';

const getters: GetterTree<State, State> = {
  getTagGroupConditions: state => {
    return state.tagFormData.tagGroupNameInfo.groupingConditions;
  },
  getTagGroupNameInfo(state: State) {
    return state.tagFormData.tagGroupNameInfo;
  },
  getTagTimeFrameInfo(state: State) {
    return state.tagFormData.timeFrameInfo;
  },
  getTagNotificationInfo(state: State) {
    return state.tagFormData.notificationInfo;
  },
  getTagFormUtilReloadTable(state: State) {
    return state.tagFormData.formUtils.reloadTagTable;
  },
  getTagTableInfo(state: State) {
    return state.tagTableInfo;
  },
  getTagFormFieldOptions(state: State) {
    return state.tagFormFieldOptions;
  },
  getTagFormUtilIsCustomExpValid(state: State) {
    return state.tagFormData.formUtils.isCustomExpValid;
  },
  getTagFormUtilGroupNameErrMsg(state: State) {
    return state.tagFormData.formUtils.groupNameErrMsg;
  }
};

export default getters;
